/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 771:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var React = __webpack_require__(15);

/**
 * I18nContext
 * Saves the I18n instance that is used by the provider
 */
var I18nContext = React.createContext({});

/**
 * useI18n
 * Hook to access the i18n context
 */
var useI18n = function useI18n() {
  return React.useContext(I18nContext);
};

/**
 * Expose I18nContext
 */
module.exports = {
  I18nContext: I18nContext,
  useI18n: useI18n
};

/***/ }),

/***/ 155:
/***/ ((module, exports, __webpack_require__) => {

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var REACT_ELEMENT_TYPE;
function _jsx(e, r, E, l) { REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol["for"] && Symbol["for"]("react.element") || 60103); var o = e && e.defaultProps, n = arguments.length - 3; if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) { for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3]; r.children = t; } if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {}); return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null }; }
/**
 * Module dependencies
 */
var React = __webpack_require__(15);
var _require = __webpack_require__(771),
  I18nContext = _require.I18nContext,
  useI18n = _require.useI18n;

/**
 * I18nProvider
 */
var I18nProvider = function I18nProvider(_ref) {
  var children = _ref.children,
    i18n = _ref.i18n;
  return /*#__PURE__*/_jsx(I18nContext.Provider, {
    value: {
      i18n: i18n
    }
  }, void 0, React.Children.only(children));
};
var injectI18n = function injectI18n(Component) {
  var InjectI18n = function InjectI18n(props) {
    var i18n = useI18n();
    return /*#__PURE__*/React.createElement(Component, _extends({}, props, i18n));
  };
  return InjectI18n;
};

/**
 * propTypes
 */

/**
 * Expose I18nProvider
 */
module.exports = I18nProvider;
exports = module.exports;
exports.I18nProvider = I18nProvider;
exports.injectI18n = injectI18n;
exports.I18nContext = I18nContext;
exports.useI18n = useI18n;

/***/ }),

/***/ 15:
/***/ ((module) => {

"use strict";
module.exports = require("react");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__(155);
/******/ 	module.exports = __webpack_exports__;
/******/ 	
/******/ })()
;